import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CanActivateUnidadeNegocio } from './can-activate-unidade-negocio';
import { UnidadeNegocioComponent } from './unidade-negocio.component';
import { UnidadeNegocioFormComponent } from './form';


@NgModule({
    imports: [
        RouterModule.forChild([
            {
                path: '',
                canActivateChild: [CanActivateUnidadeNegocio],
                children: [
                    {path: '', component: UnidadeNegocioComponent},
                    {path: 'novo', component: UnidadeNegocioFormComponent},
                    {path: ':id', component: UnidadeNegocioFormComponent}
                ]
            }
        ])
    ],
    exports: [
        RouterModule
    ],
    providers: [
        CanActivateUnidadeNegocio
    ]
})
export class UnidadeNegocioRoutingModule { }
